import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/authContext';
import { Box } from '@mui/material';
import EditableList from '../EditableList/EditableList';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

function CopagoGroupManagement() {
  const authCtx = useContext(AuthContext);

  if (!authCtx.checkRight('copagoGroup:read')) {
    return <Navigate to='/welcome' replace />;
  }

  const schema = {
    copagoId: {
      label: 'Copago Warengruppe ID',
      type: 'number',
      required: true,
      minWidth: '160px',
    },
    name: {
      label: 'Name',
      type: 'text',
      required: true,
      minWidth: '260px',
    },
    superGroup: {
      label: 'Oberwarengruppe',
      type: 'text',
      required: false,
      minWidth: '260px',
    },
    isGastro: {
      label: 'Gastronomie (Upsell)',
      type: 'boolean',
      required: false,
      minWidth: '160px',
    },
    active: {
      label: 'Aktiv',
      type: 'boolean',
      required: true,
      minWidth: '120px',
    },
  };

  return (
    <Box sx={viewRootTextPrimarySx}>
    <EditableList
      schema={schema}
      title='Neue Warengruppe anlegen'
      resourceType='copagoGroup'
      searchPlaceholder='Copago Gruppen durchsuchen'
      parentIsEditable={authCtx.checkRight('copagoGroup:update')}
      options={{ titleKey: 'name' }}
    />
    </Box>
  );
}

export default CopagoGroupManagement;
